import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { environment } from '../environments/environment';
import { ModalHostComponent } from './shared/components/modal-host/modal-host.component';
import { ChatService } from './shared/services/chat.service';
import { TrackingService } from './shared/services/tracking.service';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalHostComponent, ToastModule, ConfirmDialogModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'opusm';
  //test comment

  constructor(private translateService: TranslateService, private authService: AuthService, private chatService: ChatService, private trackingService: TrackingService) {
  }

  ngOnInit() {
    this.translateService.setFallbackLang('de');
    // check version and clear local storage if necessary
    if (localStorage.getItem('version') === null || localStorage.getItem('version') !== environment.version) {
      localStorage.clear();
      localStorage.setItem('version', environment.version);
    }

    // Initialize tracking with proper Cookiebot consent checking
    this.trackingService.initializeTracking();
  }

}
